/*
 * Minutedrone : bouton « Recevoir un devis » du panier (backlog t73, option D ; envoi par e-mail : t77).
 * Le bouton est rendu par snippets/devis-minutedrone-bouton.liquid (sous « Payer », tiroir et page panier).
 * Au clic : formulaire, puis le script Google de la boutique (attribut data-endpoint de la balise script)
 * relit le panier chez Shopify, fabrique le PDF et l'envoie par e-mail au client, copie à info@ ; le PDF
 * renvoyé se télécharge aussi. Script absent ou en panne : ancien fonctionnement (PDF fabriqué dans le
 * navigateur avec jsPDF, copie envoyée à Minutedrone par le formulaire de contact Shopify).
 */
(function () {
  if (window.__devisMinutedrone) return;
  window.__devisMinutedrone = true;

  var script = document.currentScript;
  var ENDPOINT = (script && script.dataset.endpoint) || '';
  var DELAI_SCRIPT = 40000; // ms ; au-delà, ancien fonctionnement
  var LIBS = [
    (script && script.dataset.jspdf) || 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
    (script && script.dataset.autotable) || 'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js'
  ];

  // Identité et règles du devis. Vide = non imprimé.
  var CONFIG = {
    societe: 'Minutedrone',
    forme: 'SARL',
    capital: '3 000 €', // obligatoire sur les documents d'une SARL (C. com., R123-238)
    siege: '12 rue Pierre Sémard, 38000 Grenoble',
    adressePostale: "4 avenue de l'Obiou, 38700 La Tronche",
    rcs: 'RCS Grenoble B 848 862 264',
    tva: 'FR20848862264',
    email: 'info@minutedrone.com',
    telephone: '', // pas de téléphone sur le devis (choix d'Aymen) : contact par e-mail
    site: 'shop.minutedrone.com',
    tauxTva: 0.2,
    validiteJours: 30,
    livraisonSeuil: 49, // € TTC : livraison offerte à partir de ce montant (après remises)
    livraisonFrais: 9.6, // € TTC en dessous du seuil (grille Shopify « France » : 9,60 €)
    couleur: [106, 103, 206] // violet Minutedrone #6a67ce
  };

  var TEXTES = {
    titre: 'Recevoir un devis',
    intro: ENDPOINT
      ? 'Indiquez vos coordonnées : votre devis PDF vous est envoyé par e-mail et se télécharge aussitôt. Il est valable ' + CONFIG.validiteJours + ' jours.'
      : 'Indiquez vos coordonnées : votre devis PDF se télécharge aussitôt. Il est valable ' + CONFIG.validiteJours + ' jours.',
    bouton: ENDPOINT ? 'Recevoir le devis' : 'Télécharger le devis',
    info: 'Vos coordonnées servent uniquement à établir ce devis et à en assurer le suivi ; une copie est transmise à Minutedrone.',
    conditions: [
      'Prix en euros. Les prix TTC incluent la TVA française de 20 %.',
      'Devis valable ' + CONFIG.validiteJours + ' jours à compter de sa date, sous réserve de disponibilité des produits.',
      'Pour commander : passez commande sur ' + CONFIG.site + ' ou écrivez à ' + CONFIG.email + ' en rappelant le numéro du devis. Paiement à la commande.'
    ]
  };

  var dialogue = null;

  document.addEventListener('click', function (e) {
    var bouton = e.target.closest && e.target.closest('[data-devis-ouvrir]');
    if (!bouton || bouton.disabled) return;
    e.preventDefault();
    ouvrir();
  });

  function ouvrir() {
    if (!dialogue) dialogue = creerDialogue();
    afficherEtape('form');
    erreur(''); // pas de message d'une tentative précédente
    dialogue.showModal();
    var premier = dialogue.querySelector('input');
    if (premier) premier.focus();
  }

  function creerDialogue() {
    injecterStyle();
    var d = document.createElement('dialog');
    d.className = 'devis-md';
    d.setAttribute('aria-labelledby', 'devis-md-titre');
    d.innerHTML =
      '<form class="devis-md__form" novalidate>' +
      '<h2 id="devis-md-titre" class="devis-md__titre">' + TEXTES.titre + '</h2>' +
      '<div data-etape="form">' +
      '<p class="devis-md__texte">' + TEXTES.intro + '</p>' +
      champ('nom', 'Nom et prénom', 'text', 'name', true) +
      champ('email', 'E-mail', 'email', 'email', true) +
      '<label class="devis-md__champ"><span>Adresse <abbr title="obligatoire">*</abbr></span>' +
      '<textarea name="adresse" rows="2" autocomplete="street-address" required></textarea></label>' +
      champ('societe', 'Société', 'text', 'organization', false) +
      champ('siret', 'SIRET', 'text', 'off', false, 'inputmode="numeric"') +
      champ('financeur', 'Organisme financeur', 'text', 'off', false) +
      // Piège à robots : invisible, laissé vide par les visiteurs.
      '<div class="devis-md__piege" aria-hidden="true"><label>Ne pas remplir ce champ' +
      '<input name="site_web" type="text" tabindex="-1" autocomplete="off"></label></div>' +
      '<p class="devis-md__info">' + TEXTES.info + '</p>' +
      '<p class="devis-md__erreur" role="alert" hidden></p>' +
      '<div class="devis-md__actions">' +
      '<button type="button" class="button-secondary" data-devis-fermer>Annuler</button>' +
      '<button type="submit" class="button" data-devis-valider>' + TEXTES.bouton + '</button>' +
      '</div></div>' +
      '<div data-etape="fin" hidden>' +
      '<p class="devis-md__texte" data-devis-resultat role="status"></p>' +
      '<div class="devis-md__actions"><button type="button" class="button" data-devis-fermer>Fermer</button></div>' +
      '</div>' +
      '</form>';
    document.body.appendChild(d);

    d.addEventListener('click', function (e) {
      if (e.target === d || (e.target.closest && e.target.closest('[data-devis-fermer]'))) d.close();
    });
    d.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      valider(d);
    });
    return d;
  }

  function champ(nom, libelle, type, auto, requis, extra) {
    return '<label class="devis-md__champ"><span>' + libelle + (requis ? ' <abbr title="obligatoire">*</abbr>' : '') + '</span>' +
      '<input name="' + nom + '" type="' + type + '" autocomplete="' + auto + '"' + (requis ? ' required' : '') + (extra ? ' ' + extra : '') + '></label>';
  }

  function afficherEtape(etape) {
    dialogue.querySelectorAll('[data-etape]').forEach(function (el) {
      el.hidden = el.getAttribute('data-etape') !== etape;
    });
  }

  function erreur(message) {
    var p = dialogue.querySelector('.devis-md__erreur');
    p.textContent = message || '';
    p.hidden = !message;
  }

  function valider(d) {
    var f = d.querySelector('form');
    var client = {};
    ['nom', 'email', 'adresse', 'societe', 'siret', 'financeur'].forEach(function (n) {
      client[n] = (f.elements[n].value || '').trim();
    });
    if (!client.nom || !client.adresse || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(client.email)) {
      erreur('Merci de renseigner votre nom, une adresse e-mail valide et votre adresse.');
      return;
    }
    if (client.siret && !/^\d{14}$/.test(client.siret.replace(/\s/g, ''))) {
      erreur('Le SIRET compte 14 chiffres.');
      return;
    }
    erreur('');
    var piege = f.elements.site_web ? f.elements.site_web.value : '';
    var bouton = d.querySelector('[data-devis-valider]');
    bouton.disabled = true;
    bouton.textContent = 'Préparation…';

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        if (!panier.items || !panier.items.length) throw new Error('vide');
        if (panier.currency && panier.currency !== 'EUR') throw new Error('devise');
        if (!ENDPOINT) return devisNavigateur(panier, client);
        return devisParEmail(panier, client, piege).then(function (rep) {
          if (rep) return rep;
          return devisNavigateur(panier, client); // script injoignable ou en panne : ancien fonctionnement
        });
      })
      .then(function (message) {
        dialogue.querySelector('[data-devis-resultat]').textContent = message;
        afficherEtape('fin');
      })
      .catch(function (err) {
        var m = err && err.message;
        if (m === 'vide') erreur('Votre panier est vide.');
        else if (m === 'devise') erreur('Le devis en ligne est établi en euros. Pour une autre devise, écrivez à ' + CONFIG.email + '.');
        else if (m === 'siret') erreur('Le SIRET compte 14 chiffres.');
        else if (m === 'champs') erreur('Merci de renseigner votre nom, une adresse e-mail valide et votre adresse.');
        else erreur('Le devis n\'a pas pu être créé. Réessayez ou écrivez à ' + CONFIG.email + '.');
      })
      .then(function () {
        bouton.disabled = false;
        bouton.textContent = TEXTES.bouton;
      });
  }

  /**
   * Devis fabriqué et envoyé par le script Google (t77). Renvoie le message à afficher,
   * ou null si le script n'a pas pu le faire (le navigateur prend alors le relais).
   * Les erreurs de saisie et le panier vide remontent comme erreurs du formulaire.
   */
  function devisParEmail(panier, client, piege) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var minuteur = ctrl ? setTimeout(function () { ctrl.abort(); }, DELAI_SCRIPT) : null;
    var corps = {
      type: 'devis',
      jeton: panier.token || '',
      nom: client.nom,
      email: client.email,
      adresse: client.adresse,
      societe: client.societe,
      siret: client.siret,
      financeur: client.financeur,
      site_web: piege,
      page: location.href.slice(0, 300)
    };
    // text/plain : requête « simple », sans pré-vérification CORS (le script Google n'en gère pas).
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(corps),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { return r.json(); })
      .then(function (rep) {
        if (minuteur) clearTimeout(minuteur);
        if (rep && rep.ok) {
          try {
            if (rep.pdf) telecharger(rep.pdf, rep.fichier || 'Devis-Minutedrone-' + rep.numero + '.pdf');
          } catch (e) {
            // e-mail parti : le téléchargement est un plus
          }
          return rep.envoye
            ? 'Votre devis n° ' + rep.numero + ' vous a été envoyé par e-mail à ' + client.email + ' et il est téléchargé. ' +
                'Vous ne le trouvez pas ? Regardez dans vos courriers indésirables.'
            : 'Votre devis n° ' + rep.numero + ' est téléchargé. Il n\'a pas pu vous être envoyé par e-mail : ' +
                'Minutedrone l\'a reçu et vous le renverra.';
        }
        var e = rep && rep.erreur;
        if (e === 'vide' || e === 'siret' || e === 'champs' || e === 'refus') throw new Error(e);
        return null;
      }, function () {
        if (minuteur) clearTimeout(minuteur);
        return null;
      });
  }

  /** Ancien fonctionnement (t73) : PDF fabriqué dans le navigateur, copie par le formulaire de contact. */
  function devisNavigateur(panier, client) {
    var devis = null;
    return chargerLibs()
      .then(function () {
        devis = calculer(panier, client);
        fabriquerPdf(devis).save('Devis-Minutedrone-' + devis.numero + '.pdf');
        return envoyerCopie(devis);
      })
      .then(function (copieOk) {
        return 'Votre devis n° ' + devis.numero + ' est téléchargé. ' +
          (copieOk
            ? 'Une copie a été transmise à Minutedrone.'
            : "La copie n'a pas pu être transmise à Minutedrone : envoyez le PDF à " + CONFIG.email + '.');
      });
  }

  function telecharger(base64, nom) {
    var bin = atob(base64);
    var octets = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) octets[i] = bin.charCodeAt(i);
    var url = URL.createObjectURL(new Blob([octets], { type: 'application/pdf' }));
    var a = document.createElement('a');
    a.href = url;
    a.download = nom;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
  }

  function chargerLibs() {
    if (window.jspdf && window.jspdf.jsPDF && window.jspdf.jsPDF.API.autoTable) return Promise.resolve();
    return LIBS.reduce(function (p, src) {
      return p.then(function () {
        return new Promise(function (ok, ko) {
          var s = document.createElement('script');
          s.src = src;
          s.onload = ok;
          s.onerror = ko;
          document.head.appendChild(s);
        });
      });
    }, Promise.resolve());
  }

  function calculer(panier, client) {
    var maintenant = new Date();
    var fin = new Date(maintenant.getTime() + CONFIG.validiteJours * 86400000);
    var lignes = panier.items.map(function (it) {
      var titre = it.product_title + (it.variant_title ? ' – ' + it.variant_title : '');
      var ttc = it.final_line_price / 100;
      return {
        designation: titre,
        sku: it.sku || '',
        quantite: it.quantity,
        puHt: it.final_price / 100 / (1 + CONFIG.tauxTva),
        totalHt: ttc / (1 + CONFIG.tauxTva)
      };
    });
    var sousTotalTtc = panier.items_subtotal_price / 100;
    var produitsTtc = panier.total_price / 100;
    var remiseTtc = Math.max(0, sousTotalTtc - produitsTtc);
    var livraisonTtc = produitsTtc >= CONFIG.livraisonSeuil ? 0 : CONFIG.livraisonFrais;
    var totalTtc = produitsTtc + livraisonTtc;
    var totalHt = Math.round(totalTtc / (1 + CONFIG.tauxTva) * 100) / 100;
    return {
      numero: 'D' + dateCompacte(maintenant) + '-' + Math.random().toString(36).slice(2, 6).toUpperCase(),
      date: dateFr(maintenant),
      validite: dateFr(fin),
      client: client,
      lignes: lignes,
      sousTotalHt: sousTotalTtc / (1 + CONFIG.tauxTva),
      remiseHt: remiseTtc / (1 + CONFIG.tauxTva),
      livraisonHt: livraisonTtc / (1 + CONFIG.tauxTva),
      totalHt: totalHt,
      tva: Math.round((totalTtc - totalHt) * 100) / 100,
      totalTtc: totalTtc
    };
  }

  function fabriquerPdf(dv) {
    var doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'a4' });
    var c = CONFIG.couleur;
    var g = 15;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.setTextColor(c[0], c[1], c[2]);
    doc.text(CONFIG.societe, g, 22);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    doc.setTextColor(70, 70, 70);
    var identite = [
      CONFIG.forme + ' ' + CONFIG.societe + (CONFIG.capital ? ' au capital de ' + CONFIG.capital : ''),
      'Siège : ' + CONFIG.siege,
      'Adresse postale : ' + CONFIG.adressePostale,
      CONFIG.rcs + ' – TVA ' + CONFIG.tva,
      CONFIG.email + (CONFIG.telephone ? ' – ' + CONFIG.telephone : '') + ' – ' + CONFIG.site
    ];
    doc.text(identite, g, 29);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(20, 20, 20);
    doc.text('DEVIS', 195, 22, { align: 'right' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    doc.text(['N° ' + dv.numero, 'Date : ' + dv.date, 'Valable jusqu\'au : ' + dv.validite], 195, 29, { align: 'right' });

    var cl = dv.client;
    var blocClient = [cl.societe, cl.nom].filter(Boolean)
      .concat(cl.adresse.split(/\r?\n/))
      .concat([cl.email, cl.siret ? 'SIRET : ' + cl.siret : '', cl.financeur ? 'Organisme financeur : ' + cl.financeur : ''])
      .filter(Boolean);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    var lignesClient = doc.splitTextToSize(blocClient.join('\n'), 77);
    var hClient = 9 + lignesClient.length * 4.4;
    doc.setDrawColor(c[0], c[1], c[2]);
    doc.setLineWidth(0.4);
    doc.roundedRect(110, 52, 85, hClient, 1.5, 1.5);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.setTextColor(c[0], c[1], c[2]);
    doc.text('CLIENT', 114, 57.5);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    doc.setTextColor(20, 20, 20);
    doc.text(lignesClient, 114, 62.5);

    var corps = dv.lignes.map(function (l) {
      return [l.designation + (l.sku ? '\nRéf. ' + l.sku : ''), String(l.quantite), eur(l.puHt), eur(l.totalHt)];
    });
    doc.autoTable({
      startY: Math.max(52 + hClient + 8, 75),
      head: [['Désignation', 'Qté', 'PU HT', 'Total HT']],
      body: corps,
      theme: 'grid',
      styles: { font: 'helvetica', fontSize: 9, cellPadding: 2.2, textColor: [20, 20, 20], lineColor: [220, 220, 220] },
      headStyles: { fillColor: c, textColor: 255, fontStyle: 'bold' },
      columnStyles: { 1: { halign: 'center', cellWidth: 14 }, 2: { halign: 'right', cellWidth: 30 }, 3: { halign: 'right', cellWidth: 30 } },
      margin: { left: g, right: g },
      didParseCell: function (data) {
        if (data.section === 'head' && data.column.index > 0) data.cell.styles.halign = data.column.index === 1 ? 'center' : 'right';
      }
    });

    var totaux = [['Sous-total produits HT', eur(dv.sousTotalHt)]];
    if (dv.remiseHt > 0.004) totaux.push(['Remise HT', '- ' + eur(dv.remiseHt)]);
    totaux.push(['Livraison HT', dv.livraisonHt > 0 ? eur(dv.livraisonHt) : 'Offerte']);
    totaux.push(['Total HT', eur(dv.totalHt)]);
    totaux.push(['TVA ' + Math.round(CONFIG.tauxTva * 100) + ' %', eur(dv.tva)]);
    totaux.push(['Total TTC', eur(dv.totalTtc)]);
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 4,
      body: totaux,
      theme: 'plain',
      styles: { font: 'helvetica', fontSize: 9.5, cellPadding: 1.6, textColor: [20, 20, 20] },
      columnStyles: { 0: { halign: 'right' }, 1: { halign: 'right', cellWidth: 32 } },
      margin: { left: 105, right: g },
      didParseCell: function (data) {
        if (data.row.index === totaux.length - 1) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fontSize = 11;
        }
      }
    });

    var y = doc.lastAutoTable.finalY + 10;
    if (y > 235) {
      doc.addPage();
      y = 20;
    }
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(c[0], c[1], c[2]);
    doc.text('Conditions', g, y);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    doc.setTextColor(60, 60, 60);
    var cond = doc.splitTextToSize(TEXTES.conditions.join('\n'), 95);
    doc.text(cond, g, y + 5);

    doc.setDrawColor(150, 150, 150);
    doc.setLineWidth(0.2);
    doc.rect(120, y - 4, 75, 34);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(20, 20, 20);
    doc.text('Bon pour accord', 123, y + 1);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(90, 90, 90);
    doc.text('Date, signature et cachet du client', 123, y + 5.5);

    var pages = doc.getNumberOfPages();
    for (var i = 1; i <= pages; i++) {
      doc.setPage(i);
      doc.setFontSize(7.5);
      doc.setTextColor(130, 130, 130);
      doc.text(CONFIG.forme + ' ' + CONFIG.societe + ' – ' + CONFIG.rcs + ' – TVA ' + CONFIG.tva + ' – Devis ' + dv.numero + ' – page ' + i + '/' + pages, 105, 288, { align: 'center' });
    }
    return doc;
  }

  function envoyerCopie(dv) {
    var cl = dv.client;
    var lignes = dv.lignes.map(function (l) {
      return '- ' + l.quantite + ' x ' + l.designation + (l.sku ? ' (réf. ' + l.sku + ')' : '') + ' : ' + eur(l.totalHt) + ' HT';
    });
    var corps = ['Devis n° ' + dv.numero + ' du ' + dv.date + ' (valable jusqu\'au ' + dv.validite + '), créé depuis le panier.', ''];
    corps.push('Client : ' + [cl.nom, cl.societe].filter(Boolean).join(' – '));
    corps.push('Adresse : ' + cl.adresse.replace(/\r?\n/g, ', '));
    if (cl.siret) corps.push('SIRET : ' + cl.siret);
    if (cl.financeur) corps.push('Organisme financeur : ' + cl.financeur);
    corps.push('', lignes.join('\n'), '');
    corps.push('Total HT : ' + eur(dv.totalHt) + ' – TVA : ' + eur(dv.tva) + ' – Total TTC : ' + eur(dv.totalTtc) +
      (dv.livraisonHt > 0 ? ' (livraison incluse)' : ' (livraison offerte)'));
    corps = corps.join('\n');

    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[name]', cl.nom);
    fd.append('contact[email]', cl.email);
    fd.append('contact[Objet]', 'Demande de devis ' + dv.numero);
    fd.append('contact[body]', corps);
    return fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        return r.ok && /contact_posted=true/.test(r.url);
      })
      .catch(function () {
        return false;
      });
  }

  function eur(n) {
    var s = (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }

  function dateFr(d) {
    return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();
  }

  function dateCompacte(d) {
    return String(d.getFullYear()).slice(2) + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
  }

  function injecterStyle() {
    var css =
      '.devis-md{width:min(520px,calc(100vw - 32px));max-height:calc(100dvh - 32px);padding:0;border:none;' +
      'border-radius:var(--style-border-radius-popover,8px);background:var(--color-background,#fff);color:var(--color-foreground,#111);' +
      'box-shadow:0 10px 40px rgb(0 0 0 / 0.25)}' +
      '.devis-md::backdrop{background:rgb(0 0 0 / 0.45)}' +
      '.devis-md__form{display:flex;flex-direction:column;gap:12px;padding:24px}' +
      '.devis-md__form [data-etape]:not([hidden]){display:flex;flex-direction:column;gap:12px}' +
      '.devis-md__titre{margin:0;font-size:1.3em}' +
      '.devis-md__texte,.devis-md__info{margin:0}' +
      '.devis-md__info{font-size:.85em;opacity:.75}' +
      '.devis-md__champ{display:flex;flex-direction:column;gap:4px;font-size:.95em}' +
      '.devis-md__champ abbr{text-decoration:none}' +
      '.devis-md__champ input,.devis-md__champ textarea{font:inherit;padding:10px 12px;' +
      'border:var(--style-border-width-inputs,1px) solid var(--color-input-border,#ccc);' +
      'border-radius:var(--style-border-radius-inputs,4px);background:var(--color-input-background,#fff);color:var(--color-input-text,#111)}' +
      '.devis-md__erreur{margin:0;color:#b00020}' +
      '.devis-md__piege{position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden}' +
      '.devis-md__actions{display:flex;gap:12px;justify-content:flex-end;flex-wrap:wrap;margin-top:4px}';
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
  }
})();
